import React from "react";

export default function Header() {
  const menuItems = [
    { name: "Главная", id: "hero" },
    { name: "Цены", id: "pricing" }, // Добавили новый раздел
    { name: "Решения", id: "solutions" },
    { name: "Проекты", id: "projects" },
    { name: "Контакты", id: "contacts" },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: "smooth",
      });
    }
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/80 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => scrollToSection("hero")}
        >
          <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center text-white font-bold">
            IT
          </div>
          <span className="font-black text-xl tracking-tight text-slate-800 uppercase">
            ОТРА-М
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="text-sm font-bold text-slate-600 hover:text-blue-600 transition-colors uppercase tracking-widest"
            >
              {item.name}
            </button>
          ))}
          <button
            onClick={() => scrollToSection("contacts")}
            className="bg-slate-900 text-white px-6 py-2.5 rounded-full text-sm font-bold hover:bg-blue-600 transition-all"
          >
            Оставить заявку
          </button>
        </div>
      </div>
    </nav>
  );
}
